import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { requirePermission } from '@/features/auth/utils/permissionGuard';
import { MARKET_PROMOTION_PERMISSIONS } from '@/constants/permissions';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { NewDonationBatchPage } from '@/features/marketPromotion/pages/NewDonationBatchPage';
import { donationCandidateSearchSchema } from '@/features/marketPromotion/types/marketPromotionP2.types';

export const Route = createFileRoute('/_auth/market-promotion/publish-panel/new')({
  beforeLoad: () => requirePermission(MARKET_PROMOTION_PERMISSIONS.PUBLISH_PANEL_CREATE),
  validateSearch: donationCandidateSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="New Donation Batch">
      <Suspense fallback={<PageLoader />}>
        <NewDonationBatchPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
